import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';

// Text on the blue-700→blue-600 gradient is white (≥ 5.17:1 at the lightest
// stop, #2563eb); the previous blue-100/200 fell to ~3.6–4.2:1 (WCAG 1.4.3).
// breadcrumbs: [{label, path?}] — items with path are clickable links; the last item (no path) is the current page
export default function PageInfoStripe({ breadcrumbs, title }) {
  const items = breadcrumbs ?? [{ label: title ?? '' }];
  const { ui } = useLanguage();

  return (
    <div className="page-stripe bg-gradient-to-r from-blue-700 to-blue-600 dark:from-blue-900/80 dark:via-blue-800/50 dark:to-dark-900 py-3 border-b border-blue-800/30 dark:border-dark-700/50">
      <div className="max-w-7xl mx-auto px-6">
        <nav aria-label={ui.breadcrumb} className="flex items-center gap-1 text-sm md:text-base font-medium flex-wrap">
          <span className="text-white dark:text-dark-300 mr-1">{ui.youAreHere}</span>
          {items.map((item, i) => (
            <span key={i} className="flex items-center gap-1">
              {i > 0 && <span aria-hidden="true" className="text-white dark:text-dark-400 mx-0.5">/</span>}
              {item.onClick ? (
                <button
                  type="button"
                  onClick={item.onClick}
                  className="text-white dark:text-dark-200 hover:text-blue-50 dark:hover:text-dark-100 underline underline-offset-2 hover:decoration-2 transition-colors"
                >
                  {item.label}
                </button>
              ) : item.path ? (
                <Link
                  to={item.path}
                  className="text-white dark:text-dark-200 hover:text-blue-50 dark:hover:text-dark-100 underline underline-offset-2 hover:decoration-2 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-white dark:text-dark-200 font-semibold" aria-current="page">
                  {item.label}
                </span>
              )}
            </span>
          ))}
        </nav>
      </div>
    </div>
  );
}
